import React, { useState } from 'react';
import { ZoomInOutlined, ZoomOutOutlined, RotateLeftOutlined, RotateRightOutlined } from '@ant-design/icons';

// Same look/behaviour as ImageComponent's preview in src/pages/profile/subComponents.js.
const controlStyle = {
    cursor: 'pointer',
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.65)',
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16,
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
};

const ImagePreviewOverlay = ({ src, onClose }) => {
    const [scale, setScale] = useState(1);
    const [rotate, setRotate] = useState(0);

    return (
        <div
            onClick={onClose}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.65)',
                zIndex: 100000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{ position: 'relative', display: 'inline-block', backgroundColor: '#fff', padding: 5, borderRadius: 4 }}
            >
                <div style={{ overflow: 'hidden', borderRadius: 4 }}>
                    <img
                        src={src}
                        alt="Preview"
                        style={{
                            maxWidth: '85vw',
                            maxHeight: '85vh',
                            display: 'block',
                            transform: `scale(${scale}) rotate(${rotate}deg)`,
                            transition: 'transform 0.2s ease-in-out',
                        }}
                    />
                </div>
                <div style={{ position: 'absolute', top: 12, right: 12, display: 'flex', flexDirection: 'column', gap: 8, zIndex: 100001 }}>
                    <div onClick={onClose} style={{ ...controlStyle, fontSize: 14, fontWeight: 'bold' }}>✕</div>
                    <div onClick={() => setScale((prev) => prev + 0.25)} style={controlStyle}><ZoomInOutlined /></div>
                    <div onClick={() => setScale((prev) => Math.max(0.25, prev - 0.25))} style={controlStyle}><ZoomOutOutlined /></div>
                    <div onClick={() => setRotate((prev) => prev - 90)} style={controlStyle}><RotateLeftOutlined /></div>
                    <div onClick={() => setRotate((prev) => prev + 90)} style={controlStyle}><RotateRightOutlined /></div>
                </div>
            </div>
        </div>
    );
};

export default ImagePreviewOverlay;
